import { application } from './application'

import PhoneInputController from './phone_input_controller'
application.register('phone-input', PhoneInputController)

import PlacesAutocompleteController from './places_autocomplete_controller'
application.register('places-autocomplete', PlacesAutocompleteController)

import TomSelectController from './tom_select_controller.js';
application.register('tom-select', TomSelectController);

import TooltipController from './tooltip_controller'
application.register('tooltip', TooltipController)

import CursorTooltipController from './cursor_tooltip_controller'
application.register('cursor-tooltip', CursorTooltipController)

import ToggleOnValueController from './toggle_on_value_controller'
application.register('toggle-on-value', ToggleOnValueController)

import DropdownController from './dropdown_controller'
application.register('dropdown', DropdownController)

import RegistrationFormController from './registration_form_controller'
application.register('registration-form', RegistrationFormController)

import EmailFormController from './email_form_controller'
application.register('email-form', EmailFormController)

import SubscriptionModalController from './subscription_modal_controller'
application.register('subscription-modal', SubscriptionModalController)

import SubscriptionStepFormController from './subscription_step_form_controller'
application.register('subscription-step-form', SubscriptionStepFormController)

import FlowFundHeaderController from './flow_fund_header_controller'
application.register('flow-fund-header', FlowFundHeaderController)

import SubscriptionEsgFormController from './subscription_esg_form_controller'
application.register('subscription-esg-form', SubscriptionEsgFormController)

import SignatureCompletionController from './signature_completion_controller'
application.register('signature-completion', SignatureCompletionController)

import DialogController from './dialog_controller'
application.register('dialog', DialogController)

import EntryFeeController from './entry_fee_controller'
application.register('entry-fee', EntryFeeController)

import CurrencyInputController from './currency_input_controller'
application.register('currency-input', CurrencyInputController)

import InvestorSelectController from './investor_select_controller'
application.register('investor-select', InvestorSelectController)

import DismissableController from './dismissable_controller'
application.register('dismissable', DismissableController)

import FlashController from './flash_controller'
application.register('flash', FlashController)

import DocumentUploadController from './document_upload_controller'
application.register('document-upload', DocumentUploadController)


import HeaderMenuController from './header_menu_controller'
application.register('header-menu', HeaderMenuController)

import HelpCardController from './help_card_controller'
application.register('help-card', HelpCardController)

import FormSubmitController from './form_submit_controller'
application.register('form-submit', FormSubmitController)

import PlatformChoiceController from './platform_choice_controller'
application.register('platform-choice', PlatformChoiceController)

import AdminTabsController from './admin/tabs_controller'
application.register('admin-tabs', AdminTabsController)


import AdminModalController from './admin/modal_controller'
application.register('admin-modal', AdminModalController)

import AdminFiltersToggleController from './admin/filters_toggle_controller'
application.register('admin-filters-toggle', AdminFiltersToggleController)

import AdminFiltersPanelController from './admin/filters_panel_controller'
application.register('admin-filters-panel', AdminFiltersPanelController)

import AdminCharacterCounterController from './admin/character_counter_controller'
application.register('admin-character-counter', AdminCharacterCounterController)

import AdminNestedFieldsController from './admin/nested_fields_controller'
application.register('admin-nested-fields', AdminNestedFieldsController)

import AdminSelectedFileController from './admin/selected_file_controller'
application.register('admin-selected-file', AdminSelectedFileController)

import AdminSidebarController from './admin/sidebar_controller'
application.register('admin-sidebar', AdminSidebarController)

import AdminResponsibleContactController from './admin/responsible_contact_controller'
application.register('admin-responsible-contact', AdminResponsibleContactController)

import AdminConventionToggleController from './admin/convention_toggle_controller'
application.register('admin-convention-toggle', AdminConventionToggleController)

import AdminFileDropzoneController from './admin/file_dropzone_controller'
application.register('admin-file-dropzone', AdminFileDropzoneController)

import ConsentManagerController from './consent_manager_controller'
application.register('consent-manager', ConsentManagerController)

import ContractPollingController from './contract_polling_controller'
application.register('contract-polling', ContractPollingController)
